import { render, staticRenderFns } from "./riskList.vue?vue&type=template&id=1a62721e"
import script from "./riskList.vue?vue&type=script&lang=js"
export * from "./riskList.vue?vue&type=script&lang=js"
import style0 from "./riskList.vue?vue&type=style&index=0&id=1a62721e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports